/* eslint-disable react/no-array-index-key */
import {ConfigObjectType} from '@wallaby-ui/core';
import {NavigationContext, Route as NavRoute, ValuesToCopy} from '@wallaby-ui/document';
import {layoutLib} from '@wallaby-ui/layout';
import React from 'react';
import {Route, Routes, useMatch} from 'react-router-dom';

type Props = {
  config: ConfigObjectType;
  navigationContext: NavigationContext;
  valuesToCopy: ValuesToCopy;
  setValuesToCopy: (newValues: ValuesToCopy) => void;
};
export const AppLayoutContent: React.FC<Props> = (props) => {
  const {config, navigationContext, valuesToCopy, setValuesToCopy} = props;
  const {isLoading, indexRoute, navConfig} = navigationContext;

  const IndexRouteComponent = indexRoute?.component && layoutLib.DynamicLayoutComponent.getComponentClass(indexRoute?.component);
  const indexRouteMatch = useMatch('/');

  const allRoutes: NavRoute[] = [
    ...(navConfig.staticRoutes ?? []),
    ...(navConfig.dynamicRoutes ?? []),
    {
      path: '*',
      component: isLoading ? navConfig.loadingComponent : navConfig.notFoundComponent,
    },
  ];
  return (
    <Routes>
      {indexRoute ? <Route path={'/'} element={<IndexRouteComponent config={config} match={indexRouteMatch} />} /> : null}
      {allRoutes.map((route, idx) => {
        const RouteComponent = layoutLib.DynamicLayoutComponent.getComponentClass(route.component);
        const pathWithParams = route.path + (route.paramsString ?? '');
        return (
          <Route
            key={pathWithParams + idx}
            path={pathWithParams}
            element={
              <RouteComponent
                // added key for remounting component on navigation change
                //  - it is necessary when navigating between routes rendering the same component
                key={pathWithParams + idx}
                config={config}
                route={pathWithParams}
                componentParams={undefined}
                valuesToCopy={valuesToCopy}
                setValuesToCopy={setValuesToCopy}
              />
            }
          />
        );
      })}
    </Routes>
  );
};
